import React from 'react';
import AnakIcon from '../CategoryImages/feature_4.png'
import '../CategoryBanner/categorybanner.css'

const BannerAnak = () => {
    return (
        <div className="banner-category">
            <div className="banner-category-row">
                <img src={AnakIcon} alt="" width="100" />
                <div className="banner-category-column">
                    <h5 className="banner-name">Anak</h5>
                    <p className="banner-name-txt">Donasi Terbuka</p>
                </div>
            </div>
        </div>
    )
}

export default BannerAnak;